import { useScrollReveal } from "@/hooks/useScrollReveal";
import {
  Zap,
  Headphones,
} from "lucide-react";
export default function WhyChooseUs() {
  const { ref, isVisible } = useScrollReveal();

  const benefits = [
    {
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/bag.svg",
      iconType: "image",
      title: "Creator-First Philosophy",
      description:
        "Every decision we make puts creators at the center. Your success is our success, and we're invested in your long-term growth.",
      gradient: "linear-gradient(137.738deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)",
    },
    {
      icon: Zap,
      iconType: "component",
      title: "Lightning-Fast Payments",
      description:
        "Daily YouTube payouts, early pay options, advances, and crypto support. Get your money when you need it.",
      gradient: "linear-gradient(137.738deg, rgb(96, 165, 250) 2.173%, rgb(59, 130, 246) 97.827%)",
    },
    {
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/two-circle.svg",
      iconType: "image",
      title: "Transparent & Fair",
      description:
        "No hidden fees, no confusing terms. We believe in complete transparency in all our partnerships and pricing.",
      gradient: "linear-gradient(137.738deg, rgb(167, 139, 250) 2.173%, rgb(139, 92, 246) 97.827%)",
    },
    {
      icon: Zap,
      iconType: "component",
      title: "Proven Track Record",
      description:
        "$75M+ in payments processed, billions of views managed, and 6,000+ creators who trust us with their business.",
      gradient: "linear-gradient(137.738deg, rgb(96, 165, 250) 2.173%, rgb(59, 130, 246) 97.827%)",
    },
    {
      icon: Headphones,
      iconType: "component",
      title: "24/7 Expert Support",
      description:
        "Our certified talent managers are always available to help you optimize and grow your creator business.",
      gradient: "linear-gradient(137.738deg, rgb(167, 139, 250) 2.173%, rgb(139, 92, 246) 97.827%)",
    },
    {
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/earth.svg",
      iconType: "image",
      title: "Global Reach",
      description:
        "Distribute your content worldwide through MSN and partner networks. Unlock audiences beyond YouTube.",
      gradient: "linear-gradient(137.738deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)",
    },
  ];

  return (
    <div
      id="why-choose-us"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-16 lg:py-8 xl:py-8 1xl:py-8 2xl:py-8 px-6 xxs:px-6 xs:px-8 sm:px-10 md:px-10 lg:px-12`}
    >
      <div className="mx-auto max-w-7xl">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-[30px] lg:gap-6 mb-16">
          <p className="text-[#757575] text-[15px] xxs:text-[15px] xs:text-[15px] sm:text-[15px] md:text-[18px] lg:text-lg 4xl:text-[24px] font-medium enfinity-subtext-font">What makes us difference from others</p>
          
          <h1 className="text-[80px] lg:text-[80px] xxs:text-[55px] 4xl:text-[90px] font-normal text-black text-center leading-[106px] xxs:leading-[80px] xs:leading-[80px] lg:leading-[106px] enfinity-header-font">
            <span>The </span>
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(to right, #00d115, #00b0ff, #9c44e9)",
              }}
            >
              Enfinity
            </span>
            <span> difference</span>
          </h1>

          <p className="text-[20px] xxs:text-[1rem] lg:text-2xl font-normal text-black text-center max-w-[728px] leading-[34px] xxs:leading-[1.7] enfinity-subtext-font">
            We are not just a platform, we are your growth partner committed to your success every step of the way.
        </p>
      </div>

        {/* Cards Grid - 2 rows, 3 columns */}
        <div className="flex flex-col gap-6">
          {/* Top Row */}
          <div className="flex flex-col lg:flex-row gap-6 justify-center">
            {benefits.slice(0, 3).map((benefit, index) => (
          <div
            key={index}
                className="bg-white border border-[#ddd] rounded-[20px] p-6 lg:p-10 flex flex-col gap-4 lg:gap-6 shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] w-full lg:w-[455px] overflow-hidden"
          >
                <div
                  className="w-[70px] h-[70px] lg:w-[85px] lg:h-[85px] rounded-[20px] flex items-center justify-center flex-shrink-0"
                  style={{ backgroundImage: benefit.gradient }}
                >
                  {benefit.iconType === "image" ? (
                    <img src={benefit.icon} alt="" className="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]" />
                  ) : (
                    <benefit.icon className="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] text-white" strokeWidth={1} />
                  )}
                </div>
                <div className="flex flex-col gap-3 lg:gap-4 flex-1 min-h-0">
                  <h2 className="text-[24px] lg:text-[20px] xl:text-[26px] font-normal text-black enfinity-header-font">
                    {benefit.title}
                  </h2>
                  <p className="text-base lg:text-lg font-normal text-black leading-[28px] lg:leading-[32px] break-words overflow-wrap-anywhere enfinity-subtext-font">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
            </div>

          {/* Bottom Row */}
          <div className="flex flex-col lg:flex-row gap-6 justify-center">
            {benefits.slice(3, 6).map((benefit, index) => (
              <div
                key={index + 3}
                className="bg-white border border-[#ddd] rounded-[20px] p-6 lg:p-10 flex flex-col gap-4 lg:gap-6 shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)] w-full lg:w-[455px] overflow-hidden"
              >
                <div
                  className="w-[70px] h-[70px] lg:w-[85px] lg:h-[85px] rounded-[20px] flex items-center justify-center flex-shrink-0"
                  style={{ backgroundImage: benefit.gradient }}
                >
                  {benefit.iconType === "image" ? (
                    <img src={benefit.icon} alt="" className="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]" />
                  ) : (
                    <benefit.icon className="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] text-white" strokeWidth={1} />
                  )}
                </div>
                <div className="flex flex-col gap-3 lg:gap-4 flex-1 min-h-0">
                  <h2 className="text-[24px] lg:text-[20px] xl:text-[27px] font-normal text-black enfinity-header-font">
                  {benefit.title}
                </h2>
                  <p className="text-base lg:text-xl font-normal text-black leading-[28px] lg:leading-[32px] break-words overflow-wrap-anywhere enfinity-subtext-font">
                  {benefit.description}
                </p>
            </div>
          </div>
        ))}
          </div>
        </div>
      </div>
    </div>
  );
}
